import * as C from '../../actionTypes/exfacilities/detail'

export const retrieveExfacility = (payload) => ({type: C.RETRIEVE_EXFACILITY, payload })
